import React from 'react';
import { CalendarCheckIcon, MessagesSquareIcon, RepeatIcon, ScaleIcon, SearchIcon, WalletIcon } from 'lucide-react';
import { Heading, Kicker, Section } from './ui';
import { benefits } from '../../data/vcars';
const ICONS = {
  search: SearchIcon,
  repeat: RepeatIcon,
  wallet: WalletIcon,
  scale: ScaleIcon,
  chat: MessagesSquareIcon,
  calendar: CalendarCheckIcon
};
export function BenefitsSection() {
  return <Section id="beneficios" className="bg-[#08090b]" data-id="element-4" data-mp="1lpdqng0h7a1k">
      <Kicker data-id="element-5" data-mp="1qohzu6neh7rw">Beneficios</Kicker>
      <Heading className="mt-4 max-w-2xl text-white" data-id="element-6" data-mp="1qmnfoujydjov">
        Todo lo que necesitás para comprar mejor
      </Heading>

      <div className="mt-10 grid gap-x-10 gap-y-2 sm:grid-cols-2 lg:grid-cols-3" data-id="element-7" data-mp="1bysmld219db9">
        {benefits.map(benefit => {
        const Icon = ICONS[benefit.icon];
        return <div key={benefit.title} className="border-t border-white/15 py-6 sm:py-8" data-id="element-8" data-mp="24m6mnk112ozl">
              <Icon className="h-8 w-8 text-[#5b83ff]" strokeWidth={1.7} data-id="element-9" data-mp="29gav67pxz52s" />
              <h3 className="font-display mt-4 text-xl font-bold text-white sm:text-2xl" data-id="element-10" data-mp="sxrtd8czvycc">
                {benefit.title}
              </h3>
              <p className="mt-2 text-base leading-relaxed text-white/60" data-id="element-11" data-mp="12n1m8qfnxl1i">
                {benefit.text}
              </p>
            </div>;
      })}
      </div>
    </Section>;
}